import React, { useState } from 'react';
import CryptoJS from 'crypto-js';

const PaymentForm = () => {
    const [amount, setAmount] = useState('');
    const [orderID, setOrderID] = useState('');
    const [paymentURL, setPaymentURL] = useState('');

    const merchantCode = 'BVIGMF';
    const secretKey = '89C4937D42D24903A2839FE6C86F5996';

    const handleSubmit = async (e) => {
        e.preventDefault();

        const params = {
            neo_MerchantCode: merchantCode,
            neo_Currency: 'VND',
            neo_Locale: 'vi',
            neo_Version: '1',
            neo_Command: 'PAY',
            neo_Amount: amount,
            neo_MerchantTxnID: `TXN_${Date.now()}`,
            neo_OrderID: orderID,
            neo_OrderInfo: orderID,
            neo_ReturnURL: 'https://google.com',
            neo_PaymentMethod: 'ATM',
        };

        // Tạo hash bảo mật
        const sortedKeys = Object.keys(params).sort();
        const hashString = sortedKeys.map(key => params[key]).join('') + secretKey;
        const secureHash = CryptoJS.SHA256(hashString).toString(CryptoJS.enc.Hex);

        // Tạo URL request
        const queryParams = new URLSearchParams({
            ...params,
            neo_SecureHash: secureHash,
        }).toString();

        const url = `https://sandbox-api.neopay.vn/pg/api/v1/paygate/neopay?${queryParams}`;
        console.log('Request URL:', url);

        // window.location.href = url;
    };


    return (
        <div>
            <h1>NeoX Payment Integration</h1>
            <form onSubmit={handleSubmit}>
                <div>
                    <label>Amount (VND): </label>
                    <input
                        type="number"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label>Order ID: </label>
                    <input
                        type="text"
                        value={orderID}
                        onChange={(e) => setOrderID(e.target.value)}
                        required
                    />
                </div>
                <button type="submit">Create Payment Link</button>
            </form>
            {paymentURL && (
                <div>
                    <h3>Payment Link:</h3>
                    <a href={paymentURL} target="_blank" rel="noopener noreferrer">
                        {paymentURL}
                    </a>
                </div>
            )}
        </div>
    );
};

export default PaymentForm;
